export default "/_next/static/assets/icons/android/android-chrome-192x192.fe1f93b66db70f9dde5ebf85065adb7f.png";